import { IComparator, NameValue } from '@infodata-group/inf-commons';

export class Devise implements IComparator {
  public code: string;
  public dateValidation: Date;
  public euroManagement: NameValue;
  public label: string;

  convert(item: any) {
    const devise = new Devise();
    devise.code = item.Code;
    devise.dateValidation = item.DateValidation;
    devise.euroManagement = item.GestionEuro;
    devise.label = item.Label;
    return devise;
  }

  toString() {
    return this.code;
  }

  compare(comparant: any): number {
    return this.code === comparant.code ? 0 : 1;
  }

  serialize() {
    return {
      Code: this.code,
      DateValidation: this.dateValidation,
      GestionEuro: this.euroManagement,
      Label: this.label,
    };
  }
}
